import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import axiosInPosp from "../../Redux/axios/AxiosInPosp";
import { Avatar, Button, Spin, Upload } from "antd/lib";
import { useDispatch, useSelector } from "react-redux";
import { CheckOutlined, DownloadOutlined } from "@ant-design/icons";
import "./onboard.css";
import ImgCrop from "antd-img-crop";
import { PdfTemplate } from "../GeneratePdf/PdfTemplate";
import Logo from "../GeneratePdf/images/logo-light-blue.png";
import PrinOffSign from "../../assets/signature/princ-officer.jpg";
import Sign from "../../assets/signature/tech-head.jpg";
import moment from "moment";
function PospProfile() {
  const dispatch = useDispatch();
  const history = useHistory();
  const OnbNum = useSelector((state) => state?.posp?.Posp);
  const [BaseUrl, setBaseURL] = useState("");
  const [profData, setProfData] = useState("");
  const [RcfileList, setRcfileList] = useState([]);
  const [editLoad, setEditLoad] = useState(false);
  const [butLoad, setbutLoad] = useState(false);
  // console.log(OTPData)

  useEffect(() => {
    const BASEURL = process.env.REACT_APP_UAT_BASE_URL;
    setBaseURL(BASEURL);
    fetchStates();
  }, [BaseUrl]);

  const fetchStates = () => {
    setEditLoad(true);
    axiosInPosp
      .get(`v1/posp/profile/edit`)
      .then((res) => {
        console.log(res);
        const PfData = res?.data?.profile;
        console.log("ProfData", PfData);
        setProfData(PfData);
        setEditLoad(false);
      })
      .catch((err) => {
        console.log(err);
        setEditLoad(false);
        if (err?.response.data.message === "Unauthenticated.") {
          dispatch({ type: "LOGOUT_POSP" });
          history.push("/");
        }
      });
  };
  const props1 = {
    multiple: false,
    accept: ".jpg, .png",
    beforeUpload: (file) => {
      setRcfileList([...RcfileList, file]);
      return false;
    },
    onRemove: (file) => {
      const index = RcfileList.indexOf(file);
      const newFileList = RcfileList.slice();
      newFileList.splice(index, 1);
      setRcfileList(newFileList);
    },
    RcfileList,
  };

  const onCropSubmit = () => {
    console.log("RcfileList", RcfileList);
    // const token = OnbNum?.accessToken;
    // const headers = {
    //   Authorization: `Bearer ${token}`,
    //   Accept: "application/json",
    // "Content-Type": "multipart/form-data",
    // };
    const formData = new FormData();
    formData.append("_method", "PATCH");
    formData.append("selfie_photo", RcfileList[0]);
    setEditLoad(true);
    axiosInPosp
      .post(`v1/posp/profile`, formData)
      .then((res) => {
        console.log(res);
        const Udata = res?.data;
        console.log(Udata);
        setProfData(Udata);
        setEditLoad(false);
        // setCurrent(current +1)
      })
      .catch((err) => {
        console.log(err.response);
        // if (err.response.data.message === "Unauthenticated.") {
        //   dispatch({ type: "RESET_UAT" });
        // }
        setEditLoad(false);
        //message.error('Invalid credentials!')
      });
  };
  const handleDownloadClick = async () => {
    setbutLoad(true);
    try {
      // const avatarBase64 = await getBase64ImageFromUrl(profData?.selfie_photo);
      const pdfData = {
        name: profData?.full_name,
        registrationNo: profData?.register_number,
        date: moment(new Date()).format("DD-MM-YYYY"),
        aadharNo: profData?.aadhar_number,
        panNo: profData?.pan_card_number,
        trainingDate: profData?.training_completed_at,
        principalOfficer: "Kameshwaran",
        technicalHead: "Sivasubramaniam",
        address:
          "NO.33/54, Mount Poonamalee Road, Near Kathipara Flyover, St. Thomas Mount, Chennai - 600016",
        logo: Logo,
        avatar: profData?.selfie_photo,
        principleSign: PrinOffSign,
        techSign: Sign,
      };

      await PdfTemplate(pdfData, setbutLoad);
    } catch (error) {
      console.error("Error", error);
    }
  };

  return (
    <>
      <div className="container justify-content-center h-100 align-items-center row bg-white">
        <Spin spinning={editLoad}>
          <div className="row py-3">
            <div className="col-xl-3 col-lg-3 col-sm-12">
              <div className="posp-pr-card">
                <Avatar
                  className="avatar-sec"
                  size="large"
                  src={
                    <div style={{ height: "100%" }}>
                      <img
                        src={profData?.selfie_photo}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "contain",
                        }}
                      ></img>
                      <div
                        className="edit-btb-dp"
                        onClick={() => console.log("Edit button clicked")}
                      >
                        <ImgCrop
                          rotationSlider
                          onModalOk={onCropSubmit}
                          modalTitle="Edit Profile Image"
                          modalOk="Crop & Save"
                        >
                          <Upload
                            {...props1}
                            maxCount={1}
                            showUploadList={false}
                          >
                            EDIT
                          </Upload>
                        </ImgCrop>
                      </div>
                    </div>
                  }
                />
                <div className="py-3">
                  <p className="pr-name">{profData?.full_name}</p>
                  <p className="pr-role">{profData?.role}</p>
                </div>
              </div>

              {profData?.kyc_status?.id >= 6 && (
                <div className="d-flex justify-content-center mt-3">
                  <Button
                    onClick={handleDownloadClick}
                    className="d-flex align-items-center"
                    loading={butLoad}
                    type="primary"
                    shape="round"
                    icon={<DownloadOutlined />}
                  >
                    Download Certificate
                  </Button>
                </div>
              )}
            </div>

            <div className="col-xl-9 col-lg-9 col-sm-12">
              <div className="pr-docs">About</div>
              <div className="w-100 d-flex align-items-center justify-content-center border-bottom p-2">
                <div className="w-50">Full Name</div>
                <div className="w-50 text-end pr-txt-end">
                  {profData?.full_name}
                </div>
              </div>
              <div className="w-100 d-flex align-items-center justify-content-center border-bottom p-2">
                <div className="w-50">Email</div>
                <div className="w-50 text-end pr-txt-end">
                  {profData?.email}
                </div>
              </div>
              <div className="w-100 d-flex align-items-center justify-content-center border-bottom p-2">
                <div className="w-50">Phone</div>
                <div className="w-50 text-end pr-txt-end">
                  {profData?.phonenumber}
                </div>
              </div>
              <div className="w-100 d-flex align-items-center justify-content-center border-bottom p-2">
                <div className="w-50">Role</div>
                <div className="w-50 text-end pr-txt-end">{profData?.role}</div>
              </div>
              <div className="w-100 d-flex align-items-center justify-content-center border-bottom p-2">
                <div className="w-50">Address</div>
                <div className="w-50 text-end pr-txt-end">
                  {profData?.address}
                  {","}
                  {profData?.state}
                  {","}
                  {profData?.pincode}
                </div>
              </div>
              <div className="pr-docs">Documents</div>
              <div className="w-100 d-flex align-items-center justify-content-center border-bottom p-2">
                <div className="w-50">Aadhar</div>
                <div className="w-50 text-end pr-txt-end">
                  {profData?.aadhar ? (
                    <span className="doc-status">
                      {profData?.aadhar_number}
                      <CheckOutlined />
                    </span>
                  ) : (
                    "Pending"
                  )}
                </div>
              </div>
              <div className="w-100 d-flex align-items-center justify-content-center border-bottom p-2">
                <div className="w-50">Pan Card</div>
                <div className="w-50 text-end pr-txt-end">
                  {profData?.pan_card ? (
                    <span className="doc-status">
                      {profData?.pan_card_number}
                      <CheckOutlined />
                    </span>
                  ) : (
                    "Pending"
                  )}
                </div>
              </div>
              <div className="w-100 d-flex align-items-center justify-content-center border-bottom p-2">
                <div className="w-50">Education Details</div>
                <div className="w-50 text-end pr-txt-end">
                  {profData?.education_details ? (
                    <span className="doc-status">
                      Submitted
                      <CheckOutlined />
                    </span>
                  ) : (
                    "Pending"
                  )}
                </div>
              </div>
              <div className="pr-docs">Bank Details</div>
              <div className="w-100 d-flex align-items-center justify-content-center border-bottom p-2">
                <div className="w-50">Account Number</div>
                <div className="w-50 text-end pr-txt-end">
                  {profData?.account_number}
                </div>
              </div>
              <div className="w-100 d-flex align-items-center justify-content-center border-bottom p-2">
                <div className="w-50">IFSC</div>
                <div className="w-50 text-end pr-txt-end">
                  {profData?.ifsc_code}
                </div>
              </div>
            </div>
          </div>
        </Spin>
      </div>
    </>
  );
}

export { PospProfile };
